import { Pagination } from "@dashboard/types";
import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const newsletterSection = "/newsletter";
export const newsletterListPath = newsletterSection;

export type NewsletterListUrlQueryParams = Pagination;

export const newsletterListUrl = (params?: NewsletterListUrlQueryParams) => {
  if (params === undefined) {
    return newsletterListPath;
  }

  return urlJoin(newsletterListPath, "?" + stringifyQs(params));
};
